import { Check, X } from "lucide-react";
import { cn } from "@/lib/utils";

const rules = [
  { label: "At least 8 characters", test: (pw: string) => pw.length >= 8 },
  { label: "Contains a number", test: (pw: string) => /\d/.test(pw) },
];

export function passwordMeetsRequirements(password: string) {
  return rules.every((r) => r.test(password));
}

export function PasswordRequirements({ password }: { password: string }) {
  if (!password) return null;

  return (
    <ul className="space-y-1 mt-2">
      {rules.map((rule) => {
        const passed = rule.test(password);
        return (
          <li key={rule.label} className={cn("flex items-center gap-1.5 text-xs", passed ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground")}>
            {passed ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
